import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../../../../core/base-component/basecomponent.component";
import { MyDeqErrorHandler } from "../../../../core/errorHandler";
import { AppService } from "../../../../service/app.service";
import { Utils } from "../../../../shared/Utils";
import { PagecontentSearchCriteriaUSTCRPage } from "./search-criteria-ust-cr.resourcebundle";
import { PersistanceService } from "../../../../service/persistance.service";
import * as _ from "lodash-es";
import { BasePathController } from "../../../components/base-path-component.component";

@Component({
  selector: "search-criteria-ust-cr",
  templateUrl: "./search-criteria-ust-cr.component.html",
})
export class SearchCriteriaUSTCRComponent extends BasePathController {
  pageForm: UntypedFormGroup;
  dbSearchForm: UntypedFormGroup;
  errorsList: any[] = [];
  fullList: any[] = [];
  requestList: any[] = [];
  requestType: string;
  searchKeys: Map<string, string[]> = new Map<string, string[]>();
  placeHolderText: string;
  searchString: string = "";
  dbForm: UntypedFormGroup;
  noRecordsFound: boolean = false;

  _sortBy: string;
  _sortOrder: string;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected formBuilder: UntypedFormBuilder,
    public utils: Utils,
    protected appService: AppService,
    protected errorHandler: MyDeqErrorHandler,
    private persister: PersistanceService,
    private router: Router
  ) {
    super(
      activatedRoute,
      formBuilder,
      utils,
      appService,
      errorHandler,
      new PagecontentSearchCriteriaUSTCRPage()
    );
    this.noGetCallOnLoad = true;
    this.dbSearchForm = this.formBuilder.group({
      searchString: new UntypedFormControl(null),
      searchCriteria: new UntypedFormControl([]),
    });
    this.pageForm = this.createForm();
    let pageContent = new PagecontentSearchCriteriaUSTCRPage();

    this.pageText = this.utils.getPathSpecificText(
      pageContent.PAGE_TEXT["base"],
      pageContent.PAGE_TEXT["searchcriteria"]
    );
    this.utils.title =
      "LEAKING UNDERGROUND STORAGE TANK (LUST) DATABASE SEARCH";
  }

  onGetResponse(getResponse: any): void {}

  createForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  loadRequestList = () => {
    this.errorsList = [];
    //this.requestList = [];
    this.fullList = [];
    //console.log("this.dbSearchForm.value", this.dbSearchForm.value);
    const request = {
      ustDataTabRequest: this.dbSearchForm.value,
    };

    let searchCriteria = [];
    for (let i = 0; i < this.dbSearchForm.value.searchCriteria.length; i++) {
      searchCriteria.push({
        searchColumn: this.dbSearchForm.value.searchCriteria[i],
      });
    }

    this.additionalPutCall({
      // /service/ust/list
      serviceURL: "list",
      putObject: this.dbSearchForm.value,
      successcallBack: (response) => {
        this.requestList = response.usts;
        if (response.usts.length == 0) {
          this.noRecordsFound = true;
        } else {
          this.noRecordsFound = false;
        }
        if (response) {
          this.requestList = response.usts
            ? response.usts.map((x) => {
                x.display_ustcase =
                  x.lustNum + "." + this.utils.prepandZero(+x.lustSeq);
                if (x.address) {
                  x.display_address =
                    x.address + " " + x.city + ", " + x.state + " " + x.zip;
                } else if (x.address && x.suiteApt) {
                  x.display_address =
                    x.address +
                    " " +
                    x.suiteApt +
                    " " +
                    x.city +
                    ", " +
                    x.state +
                    " " +
                    x.zip;
                } else {
                  x.display_address = x.lattitude + "/" + x.longitude;
                }
                return x;
              })
            : response.usts;
        }

        // console.log(this.requestList)
        this.persister.set(
          this.requestType + "ustDataTabFilter",
          request.ustDataTabRequest
        );

        let searchCriteriaArray: string[] = this.dbSearchForm.get(
          "searchCriteria"
        ).value
          ? this.dbSearchForm.get("searchCriteria").value
          : [];
        if (
          (this.requestList == null || this.requestList.length <= 0) &&
          this.dbSearchForm.get("searchString").value != null &&
          this.dbSearchForm.get("searchString").value != "" &&
          searchCriteriaArray &&
          searchCriteriaArray.length > 0
        ) {
          this.errorsList.push(
            "No records found, please update the search criteria"
          );
        }
      },
      errorcallBack: (error) => {
        this.handleError(error);
        this.onPutError(error);
      },
    });
  };

  ngAfterViewInit() {}

  download() {
    // https://mydev.azdeq.gov/deq-search/service/lust/download
    // const filedownloadBasePath = '/mydeq-ust-confirm-release/service/confirmrelease/' + this.utils.path[1] + '/downloadByDocId/'
    const filedownloadBasePath = "/deq-search/service/lust/download";
    window.open(filedownloadBasePath, "_blank");
  }

  updatedSearchList(value: any[]) {
    this.requestList = value;
  }

  viewFacilityDetails(record) {
    // console.log(this.utils.navigateTo(['lust', 'cases', releaseIdno], false))

    this.utils.navigateTo(
      [
        "lust",
        "cases",
        record.lustNum + "." + this.utils.prepandZero(+record.lustSeq),
      ],
      false
    );
    // this.utils.navigateTo(['lust', 'cases', record.releaseIdno], false)
  }

  handleSortBy = (sortby: string) => {
    this._sortBy = sortby;
  };

  setSearchColumn(id: string, colId: string) {
    const isSelected = (<HTMLInputElement>document.getElementById(id)).checked;
    let searchCriteriaArray: string[] = this.dbSearchForm.get("searchCriteria")
      .value
      ? this.dbSearchForm.get("searchCriteria").value
      : [];
    let valueArry = [];
    if (colId.indexOf(",") !== -1) {
      valueArry = colId.split(",");
    } else {
      valueArry.push(colId);
    }
    if (isSelected) {
      searchCriteriaArray = [...searchCriteriaArray, ...valueArry];
    } else {
      const indexx = searchCriteriaArray.indexOf(valueArry[0]);
      searchCriteriaArray.splice(indexx, valueArry.length);
    }
    this.dbSearchForm.get("searchCriteria").reset(searchCriteriaArray);
  }

  resetLocalStorage() {
    this.dbSearchForm.get("searchCriteria").setValue([]);
    this.dbSearchForm.get("searchString").reset(null);
    this.requestList = [];
    this.persister.set(this.requestType + "ustDataTabFilter", {
      searchString: null,
      searchCriteria: [],
    });
  }

  updateFilters(savedFilter) {
    savedFilter = savedFilter
      ? savedFilter
      : { searchString: null, searchCriteria: [] };
    this.dbSearchForm.reset({
      searchString: savedFilter.searchString,
      searchCriteria: savedFilter.searchCriteria,
    });
  }

  searchRequest = () => {
    this.errorsList = [];
    // this.errorFields = [];
    let searchCriteriaArray: string[] = this.dbSearchForm.get("searchCriteria")
      .value
      ? this.dbSearchForm.get("searchCriteria").value
      : [];
    // console.log(' searchCriteriaArray : ', searchCriteriaArray);
    if (
      this.dbSearchForm.get("searchString").value != null &&
      this.dbSearchForm.get("searchString").value != "" &&
      searchCriteriaArray &&
      searchCriteriaArray.length > 0
    ) {
      //console.log(' load ')
      this.loadRequestList();
    } else {
      if (
        this.dbSearchForm.get("searchString").value == null ||
        this.dbSearchForm.get("searchString").value == ""
      ) {
        // this.errorFields.push({ 'searchString': true });
        this.errorsList.push("Please enter the search text.");
        //return;
      }
      if (searchCriteriaArray == null || searchCriteriaArray.length == 0) {
        //this.errorFields.push({'searchCriteria':true});
        // this.errorFields['searchCriteria'] = true
        this.errorsList.push(
          "CHECKBOX UNCHECKED: Please select one or more that apply."
        );
        //return;
      }
      // console.log(' this.errorFields ', this.errorFields);
    }
  };

  pageNumberChangeHandler = (pagenumber) => {
    // console.log("Pag number change ===>", pagenumber)
  };

  goBack = () => {
    window.location.href = "https://www.azdeq.gov/databases";
  };
}
